// extracted by mini-css-extract-plugin
export var banner = "_p1-0";
export var settingRow = "_p1-2";
export var titleIcon = "_p1-1";